
import { debounce } from "lodash";
import { ref } from "vue";
import { defineComponent } from "vue";
import { Filter } from "@/types/filter.type";
import { SamplingPoint } from "@/types/samplingpoint.type";
import PageHeaderComponent from "../PageHeader.component.vue";
import HistoricStationTable from "@/components/stations/HistoricStationTable.component.vue";
import { ElRowClassNameParams } from "@/types/element.type";
import { Parameter } from "@/types/parameter.type";

export default defineComponent({
  components: { PageHeaderComponent, HistoricStationTable },
  props: {
    canWrite: {
      type: Boolean,
      default: false,
    },
    containerId: {
      type: Number,
    },
    detailRouterName: {
      type: String,
    },
    onClick: {
      type: Function,
      required: false,
    },
  },

  watch: {
    value1() {
      this.currentPage = 1;
      this.refreshEntities();
    },
  },

  data() {
    return {
      entities: [] as SamplingPoint[],
      currentPage: 0 as number,
      rowPerPage: 10 as number,
      totalRows: 0 as number,
      query: "" as string,
      showEntityForm: false,
      showEntityInfo: false,
      optionspro: [
        { value: "PRODUCTION", label: "Producción" },
        { value: "ESTIMATION", label: "Estimación" },
      ],
      optionspre: [
        { value: "CALIBRATION", label: "Calibración" },
        { value: "STATION", label: "Estación" },
      ],
      samplingPointSelected: undefined as undefined | SamplingPoint,
      showHistoricTable: false,
      alertForm: undefined as undefined,
      value1: "", // Aquí se declara correctamente

      options: [
        { value: "PRODUCTION", label: "Producción" },
        { value: "CALIBRATION", label: "Calibracion" },
      ],
    };
  },
  created() {
    // - apply delay
    this.search = debounce(this.refreshEntities, 300);
  },
  mounted() {
    this.currentPage = 1;
    this.refreshEntities();
  },
  methods: {
    search(): void {
      this.refreshEntities();
    },

    openHistoricTableDialog() {
      this.showHistoricTable = true;
    },
    closeHistoricTableDialog() {
      this.showHistoricTable = false;
    },

    changePaginationSize(size: number): void {
      this.rowPerPage = size;
      this.refreshEntities();
    },

    changePaginationPage(page: number): void {
      this.currentPage = page;
      this.refreshEntities();
    },
    /**
     * table row css class name
     * @param params
     * @return css class name
     */
    tableRowClassName(params: ElRowClassNameParams<SamplingPoint>): string {
      return params.row && params.row.status ? "" : "disable-row";
    },

    async refreshEntities(item: SamplingPoint | undefined = undefined) {
      let index = -1;
      if (this.entities && item) {
        index = this.entities.findIndex((i) => i.id === item.id);
      }
      if (index !== -1 && item) {
        this.entities[index] = item;
      } else {
        const filter: Filter = {};

        if (this.query) {
          filter.multi = this.query;
        }
        filter.fields = {};
        if (this.containerId) {
          filter.fields["container.id"] = {
            operator: "equal",
            value: this.containerId,
          };
        }
        if (this.value1) {
          filter.fields["type"] = {
            operator: "equal",
            value: this.value1,
          };
        }
      }
    },
  },
});
